import apiClient from '../apiClient';
import { POST_IMAGE_TRANSPORTATION_PROFILE_URL } from '../apiUrl';

const postUploadImageTransportationProfileApi = (Id, data) => {
  return apiClient.post(POST_IMAGE_TRANSPORTATION_PROFILE_URL(Id), data);
};

export default postUploadImageTransportationProfileApi;
